// Ask Allen conversation memory — a module-level reactive thread so the chat
// survives closing/reopening the docked panel and navigating between surfaces.
// Backed by sessionStorage, so it also survives a page reload but clears when the
// tab/session is closed. Keyed by mode ('demo' | 'live') so the two never mix.
import { reactive, watch } from 'vue'

const KEY = 'allen_thread_v1'

let init = {}
try { init = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {} } catch { init = {} }

const store = reactive({
  demo: Array.isArray(init.demo) ? init.demo : [],
  live: Array.isArray(init.live) ? init.live : [],
})

watch(store, () => {
  try { sessionStorage.setItem(KEY, JSON.stringify(store)) } catch { /* quota/private mode */ }
}, { deep: true })

// The reactive thread array for a mode — push {q, a} onto it; persistence is automatic.
export function allenThreadFor(mode) {
  return mode === 'demo' ? store.demo : store.live
}

export function clearAllenThread(mode) {
  const arr = allenThreadFor(mode)
  arr.splice(0, arr.length)
}
